import { connectUtil, PropsFromRedux } from "base/src/utils/reduxUtil";
import { RootStateCampanha } from "../../../../store/campanhaReducer";
import { LotePedidoResponse } from "../../../../types/lotePedido/lotePedidoResponse";
import { Button } from "base/src/components/Button";
import { ModalClose } from "base/src/components/Modal";
import * as S from './ModalDeletarPagamentoStyles';
import { _UserData, UserDataBaseEnum } from "base/src/infra/storage/localStorage";
import { DeletarLote } from "../../../../store/pedidoLotes/actions/pedidoLotesAction";
import { DeletarPedidoRequest } from "../../../../types/lotePedido/deletarPedidoRequest";

const connector = connectUtil(
  (state: RootStateCampanha) => ({
    CarteiraUsuarioInfo: state.CarteiraBaseReducer.CarteiraUsuario
  }),
  { DeletarLote }
);

export interface ModalDeletarLoteProps extends PropsFromRedux<typeof connector> {
  loteItem: LotePedidoResponse;
  onCancel?: () => void;
  onConfirm?: () => void;
}

function ModalDeletarLote(props: ModalDeletarLoteProps) {

  function handleDeletarLote() {
    const request: DeletarPedidoRequest = {
      LoteID: props.loteItem.CampanhaPedidoResgatePagamentoID,
      Usuario: _UserData.Get<string>(UserDataBaseEnum.UsuarioAcesso),
      PagamentoStatusID: props.loteItem.CampanhaPedidoResgatePagamentoStatusID
    };

    props.DeletarLote(request);

    if (props.onConfirm) {
      props.onConfirm();
    }

    if (props.onCancel) {
      props.onCancel();
    }
  }

  return (
    <S.Container>
      <S.Title>Deletar Lote - {props.loteItem.Nome}</S.Title>
      <S.Title></S.Title>

      <div style={{
        padding: '16px',
        backgroundColor: '#f8d7da',
        borderRadius: '8px',
        border: '1px solid #f5c6cb',
        color: '#721c24',
        fontSize: '14px',
        textAlign: 'center',
      }}>
        <strong>⚠️ ATENÇÃO</strong>
        <br />
        Esta ação não pode ser desfeita. O lote será excluído permanentemente do sistema.
      </div>

      <S.ButtonContainer>
        <ModalClose asChild>
          <Button
            size="md"
            variant="secondary"
            full
            onClick={props.onCancel}
          >
            Cancelar
          </Button>
        </ModalClose>
        <ModalClose asChild>
          <Button
            size="md"
            variant="danger"
            full
            onClick={handleDeletarLote}
          >
            Deletar Lote
          </Button>
        </ModalClose>
      </S.ButtonContainer>
    </S.Container>
  );
}

export default connector(ModalDeletarLote);